import React from 'react'

import { ReactPSUPriceProps } from './types'
import { GREEN_PRICE_TAG, PRICE_TAG } from '../../../assets/images'
import ReactText from '../../ReactText'
import './ReactPSUPrice.scss'

const ReactPSUPrice = (props: ReactPSUPriceProps): React.JSX.Element => {
  const {
    variation,
    planName,
    priceChangeText,
    changeSign,
    price,
    scratchPrice,
    newBillText,
    discount,
    priceTagIcon = PRICE_TAG,
    priceTagIconAlt,
    savingsMsg,
    savingsPriceTagIcon = GREEN_PRICE_TAG,
    savingsPriceTagIconAlt,
    term
  } = props

  return (
    <div className={`react-psu-price-container variation-${variation}`}>
      <div className='price-section-top'>
        {planName && <ReactText className='plan-name' text={planName} isParsed />}
        {priceChangeText && <ReactText className='price-change-text' text={priceChangeText} isParsed />}
      </div>

      <div className='price-section-middle'>
        <div className='price-change'>
          {changeSign && <ReactText className='plan-price-actual' text={changeSign} isParsed />}
          {price && <ReactText className='plan-price-actual' text={price} isParsed />}
        </div>
        {scratchPrice && <ReactText className='plan-price-crossed-out' text={scratchPrice} isParsed />}
      </div>

      <div className='price-section-bottom'>
        {newBillText && <ReactText className='new-bill-text' text={newBillText} isParsed />}
        {discount && discount.length > 0 && (
          <div className='icon-with-text'>
            {priceTagIcon && (
              <img src={priceTagIcon} className='price-tag-icon' aria-label='price-tag-icon' alt={priceTagIconAlt}></img>
            )}
            <ReactText text={discount} isParsed />
          </div>
        )}
        {term && (
          <div className='icon-with-text'>
            {priceTagIcon && <img src={priceTagIcon} className='price-tag-icon' aria-label='price-tag-icon'></img>}
            <ReactText text={term} isParsed />
          </div>
        )}
        {savingsMsg && savingsMsg.length > 0 && (
          <div className='icon-with-text'>
            {savingsPriceTagIcon && (
              <img
                src={savingsPriceTagIcon}
                className='price-tag-icon'
                aria-label='price-tag-icon'
                alt={savingsPriceTagIconAlt}
              ></img>
            )}
            <ReactText text={savingsMsg} isParsed />
          </div>
        )}
      </div>
    </div>
  )
}
export default ReactPSUPrice
